import type { RefObject } from 'react';
import { revealRectangle } from 'util/animation/reveal/reveal';

interface ImageGrid5Refs {
  elementRef: RefObject<HTMLElement | null>;
}

interface ImageShiftRefs {
  imageItemRefs: RefObject<Array<HTMLDivElement | null>>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: ImageGrid5Refs,
): void {
  const imageItems = Array.from(elementRef.current?.children ?? []).filter(
    (child): child is HTMLElement => child instanceof HTMLElement,
  );

  if (imageItems.length > 0) {
    timeline.add(
      revealRectangle(imageItems, {
        from: 'bottom',
        duration: 0.5,
        stagger: 0.1,
      }),
      0,
    );
  }
}

export function imageShiftTimeline(
  timeline: gsap.core.Timeline,
  { imageItemRefs }: ImageShiftRefs,
): void {
  imageItemRefs.current.forEach((imageItemRef, index) => {
    if (!imageItemRef) return;

    timeline.to(
      imageItemRef,
      {
        yPercent: (index + 1) * 5,
        ease: 'none',
      },
      0,
    );
  });
}

export function setupTransitionOutTimeline(): void {
  // timeline.add(fadeTo(elementRef.current as HTMLElement));
}
